import React from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";

import Header from "./components/Header";
import Home from "./pages/Home";
import FooterWithBanner from "./components/FooterWithBanner";
import Landing from "./pages/Landing";
import FlipScroll from "./pages/FlipScroll";


import ProductsGrid from "./../src/components/ProductForm/products-grid";
import OnboardingForm from "./../src/components/ProductForm/OnBoardingForm";
import ThankYouPage from "./components/ProductForm/ThankYouPage";

function ProductsPage() {
  const navigate = useNavigate();
  return <ProductsGrid onStartApply={() => navigate("/apply")} />;
}


export default function App() {
  return (
    <>
      {/* Common Header on all pages */}
     

      {/* Routes */}
      <Routes>
        {/* <Route path="/" element={<Home />} />  */}
        <Route path="/processing" element={<FlipScroll />} />
        <Route path="/" element={<Landing />} />
        <Route path="/thankyou" element={<ThankYouPage />} />
        <Route path="/careers" element={<div style={{ padding: 24 }}>Careers Page</div>} />
        <Route path="/support" element={<div style={{ padding: 24 }}>Support Page</div>} />


        <Route path="/Products" element={<ProductsPage />} />
        <Route path="/apply" element={<OnboardingForm />} />


      </Routes>

      {/* Common Footer on all pages */}
      
    </>
  );
}








